import { GroupPersonItem, TeamCanType } from "../../../../../../../API/teams";
import classNames from "classnames";
import Style from "./index.module.scss";
import React from "react";

export default function mobileTd(data: GroupPersonItem) {
    return (
        <div>
            <h1
                className={classNames(
                    Style.mobileH1,
                    data?.isGroupLeader === TeamCanType.yes && Style.leader
                )}>
                {data?.name}
                {data?.isGroupLeader === TeamCanType.yes && "(组长)"}
            </h1>
            <h2 className={Style.mobileH2}>{data.memberNo}</h2>
        </div>
    );
}
